export enum APP_STATE_AS_CONTENT_ENUM {
    PLAN_NAME = 'PLAN_NAME',
    PLAN_PRICE = 'PLAN_PRICE',
    PLAN_COUNTY = 'PLAN_COUNTY',
    PLAN_START_DATE = 'PLAN_START_DATE',
    PLAN_RATING_ENTITY = 'PLAN_RATING_ENTITY'
}
export type APP_STATE_AS_CONTENT_ENUM_AS_JSON_TYPE = { [key: string]: APP_STATE_AS_CONTENT_ENUM };

export interface APP_STATE_AS_CONTENT_ENUM_AS_JSON extends APP_STATE_AS_CONTENT_ENUM_AS_JSON_TYPE {
    PLAN_NAME: APP_STATE_AS_CONTENT_ENUM;
    PLAN_PRICE: APP_STATE_AS_CONTENT_ENUM;
    PLAN_COUNTY: APP_STATE_AS_CONTENT_ENUM;
    PLAN_START_DATE: APP_STATE_AS_CONTENT_ENUM;
    PLAN_RATING_ENTITY: APP_STATE_AS_CONTENT_ENUM;
}
